/* La PRESENCIA del Oraculo: orbe de labradorita VIVA en raw-WebGL (sphere impostor + thin-film).
   Mejora progresiva: el <img> de respaldo ya es valido; este JS solo lo enriquece si hay WebGL.
   prefers-reduced-motion / sin WebGL / error -> se queda la imagen. Cero dependencias. */
(function () {
  'use strict';
  if (window.__mpOrbe) return; // singleton (el snippet podria incluirse 2 veces)
  var root = document.querySelector('.oraculo-orbe[data-tex]');
  if (!root) return;
  // La orbe no se enriquece detras del chasis de una pantalla-app (cotizador / contador /
  // japa): ahi vive TAPADA por el cuarto (.mp-app-room, z-index 50). El <a>/<img> estatico
  // del snippet se queda (0 costo); esto aborta ANTES de bajar la textura, crear el canvas
  // y correr el loop. La landing de la Sala y la de resenas NO traen chasis: ahi sigue viva.
  if (document.querySelector('.mp-app-room[data-room]')) return;
  // Datos frugales: en ahorro de datos o red 2G se queda el <img> de respaldo (9KB, digno).
  // navigator.connection no existe en Safari iOS (undefined -> se enriquece con normalidad).
  var mpConn = navigator.connection;
  if (mpConn && (mpConn.saveData === true || /(^|-)2g/.test(mpConn.effectiveType || ''))) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return; // quietud total: se queda el <img>

  // --- deteccion WebGL ---
  var probe = document.createElement('canvas');
  var gl = probe.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false, powerPreference: 'low-power', depth: false, stencil: false })
        || probe.getContext('experimental-webgl');
  if (!gl) return; // sin WebGL: se queda el <img>
  window.__mpOrbe = true;

  var TEX_URL = root.getAttribute('data-tex');

  // --- canvas real, encima del img ---
  var canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border-radius:50%;opacity:0;transition:opacity .6s ease;pointer-events:none';
  root.appendChild(canvas);
  gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false, antialias: false, powerPreference: 'low-power', depth: false, stencil: false })
    || canvas.getContext('experimental-webgl');
  if (!gl) { canvas.remove(); return; }

  var deriv = gl.getExtension('OES_standard_derivatives');

  // --- shaders ---
  var VERT = 'attribute vec2 pos; varying vec2 vUv; void main(){ vUv = pos*0.5+0.5; gl_Position = vec4(pos,0.0,1.0); }';
  var FRAG =
    (deriv ? '#extension GL_OES_standard_derivatives : enable\n#define DERIV\n' : '') +
    'precision highp float;\n' +
    'varying vec2 vUv;\n' +
    'uniform sampler2D uTex; uniform vec2 uLight; uniform float uTime, uMotion, uFireGain;\n' +
    'float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}\n' +
    'float vnoise(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.0-2.0*f);\n' +
    ' return mix(mix(hash(i),hash(i+vec2(1.0,0.0)),f.x),mix(hash(i+vec2(0.0,1.0)),hash(i+vec2(1.0,1.0)),f.x),f.y);}\n' +
    'float fbm(vec2 p){float s=0.0,a=0.5;for(int i=0;i<3;i++){s+=a*vnoise(p);p*=2.03;a*=0.5;}return s;}\n' +
    'vec3 pal(float t){vec3 a=vec3(0.20,0.38,0.42),b=vec3(0.42,0.44,0.50),c=vec3(1.0),d=vec3(0.00,0.18,0.55);return a+b*cos(6.28318*(c*t+d));}\n' +
    'void main(){\n' +
    ' vec2 p=vUv*2.0-1.0; float r2=dot(p,p); if(r2>1.0) discard;\n' +
    ' float z=sqrt(1.0-r2); vec3 N=vec3(p,z);\n' +
    ' float ang=uTime*0.04*uMotion; mat2 R=mat2(cos(ang),-sin(ang),sin(ang),cos(ang));\n' +
    ' vec2 uv=(R*p)*0.5+0.5; uv+=N.xy*0.030*(1.0-z);\n' +
    ' vec4 tx=texture2D(uTex,uv); vec3 albedo=tx.rgb; float flake=tx.a;\n' +
    ' float lum=dot(albedo,vec3(0.299,0.587,0.114));\n' +
    ' vec3 Np;\n' +
    '#ifdef DERIV\n' +
    ' Np=normalize(N+vec3(-dFdx(lum),-dFdy(lum),0.0)*1.5);\n' +
    '#else\n' +
    ' Np=N;\n' +
    '#endif\n' +
    ' vec3 V=vec3(0.0,0.0,1.0), L=normalize(vec3(uLight*1.2,0.85)), H=normalize(L+V);\n' +
    ' float ndv=clamp(dot(Np,V),1e-3,1.0), ndh=max(dot(Np,H),0.0);\n' +
    ' float breath=fbm(N.xy*3.0+vec2(0.0,uTime*0.05*uMotion));\n' +
    ' float ndvT=max(ndv,0.28); float thick=(0.55+0.45*breath)*(1.0/ndvT);\n' +
    ' float phase=thick*2.6+ndh*1.4;\n' +
    ' vec3 irid=pal(fract(phase)); irid=mix(irid,irid*albedo*2.2,0.5);\n' +
    ' float fres=pow(1.0-ndv,3.0);\n' +
    ' float sheet=smoothstep(0.45,0.95,ndh);\n' +
    ' float spark=smoothstep(0.93,1.0,sin(phase*9.4248)*0.5+0.5);\n' +
    ' float fire=flake*(sheet*0.8+spark*0.6+fres*0.5)*uFireGain;\n' +
    ' fire*=(0.7+0.3*sin(uTime*0.9))*uMotion+(1.0-uMotion);\n' +
    ' vec3 col=albedo*0.85;\n' +
    ' col+=irid*fire*1.5;\n' +
    ' col+=pal(fract(phase+0.3))*fres*0.35;\n' +
    ' col*=0.78+0.22*z;\n' +
    ' col+=(hash(gl_FragCoord.xy)-0.5)/255.0;\n' +
    ' float edge=smoothstep(1.0,0.985,r2);\n' +
    ' gl_FragColor=vec4(col*edge,edge);\n' + // premult por edge para borde limpio
    '}';

  function compile(type, src) {
    var sh = gl.createShader(type);
    gl.shaderSource(sh, src); gl.compileShader(sh);
    if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) { return null; }
    return sh;
  }
  var prog, uTex, uLight, uTime, uMotion, uFire;
  function buildProgram() {
    var vs = compile(gl.VERTEX_SHADER, VERT), fs = compile(gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) return false;
    prog = gl.createProgram(); gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return false;
    gl.useProgram(prog);
    var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'pos'); gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    uTex = gl.getUniformLocation(prog, 'uTex'); uLight = gl.getUniformLocation(prog, 'uLight');
    uTime = gl.getUniformLocation(prog, 'uTime'); uMotion = gl.getUniformLocation(prog, 'uMotion');
    uFire = gl.getUniformLocation(prog, 'uFireGain');
    gl.enable(gl.BLEND); gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA); // premultiplied
    gl.clearColor(0, 0, 0, 0);
    return true;
  }

  var tex = null, texReady = false;
  function loadTexture() {
    var img = new Image(); img.decoding = 'async';
    img.onload = function () {
      tex = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, tex);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); // sin mipmaps: NPOT-safe y mas nitido a este tamano
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      texReady = true;
      maybeRun();
    };
    img.src = TEX_URL;
  }

  // --- tamano / DPR ---
  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = Math.max(1, Math.round(root.clientWidth * dpr));
    var h = Math.max(1, Math.round(root.clientHeight * dpr));
    if (canvas.width !== w || canvas.height !== h) { canvas.width = w; canvas.height = h; gl.viewport(0, 0, w, h); }
  }

  // --- reactividad: pointer + tilt + auto-orbita Lissajous, suavizada ---
  var curX = 0, curY = 0, tgtX = 0, tgtY = 0, srcX = null, srcY = null, lastInput = -1e9;
  function onPointer(e) { srcX = (e.clientX / window.innerWidth) * 2 - 1; srcY = -((e.clientY / window.innerHeight) * 2 - 1); lastInput = now(); }
  function onTilt(e) {
    if (e.gamma == null && e.beta == null) return;
    var g = Math.max(-35, Math.min(35, e.gamma || 0)), b = Math.max(-35, Math.min(35, (e.beta || 0) - 35));
    srcX = g / 35; srcY = -b / 35; lastInput = now();
  }
  var now = (window.performance && performance.now) ? function () { return performance.now(); } : function () { return +new Date(); };

  // permiso iOS: enganchar al primer pointerdown del orbe (no bloquea la navegacion del <a>)
  function armTilt() {
    var DOE = window.DeviceOrientationEvent;
    if (!DOE) return;
    if (typeof DOE.requestPermission === 'function') {
      root.addEventListener('pointerdown', function once() {
        root.removeEventListener('pointerdown', once);
        DOE.requestPermission().then(function (s) { if (s === 'granted') window.addEventListener('deviceorientation', onTilt); }).catch(function () {});
      });
    } else {
      window.addEventListener('deviceorientation', onTilt);
    }
  }

  // --- loop ---
  var raf = 0, t0 = now(), lastFrame = 0, running = false, visible = true, inView = true, hoverGain = 0;
  function lissajous(t) { return [Math.cos(t / 14000 * 6.283) * 0.6, Math.sin(t / 19000 * 6.283) * 0.6]; }
  function frame() {
    raf = 0;
    if (!running) return;
    var t = now() - t0;
    var idle = (now() - lastInput) > 30000;
    var fpsGate = idle ? 80 : 28; // ~12fps idle, ~36fps activo
    if (t - lastFrame < fpsGate) { schedule(); return; }
    lastFrame = t;
    resize();
    var auto = lissajous(t);
    if (srcX != null && (now() - lastInput) < 2500) { tgtX = auto[0] * 0.3 + srcX * 0.8; tgtY = auto[1] * 0.3 + srcY * 0.8; }
    else { tgtX = auto[0]; tgtY = auto[1]; }
    curX += (tgtX - curX) * 0.08; curY += (tgtY - curY) * 0.08;
    var wantHover = (root.matches(':hover') || root.matches(':focus-within')) ? 1 : 0;
    hoverGain += (wantHover - hoverGain) * 0.12;
    if (!texReady) { schedule(); return; }
    gl.uniform1i(uTex, 0); gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.uniform2f(uLight, curX, curY);
    gl.uniform1f(uTime, t / 1000);
    gl.uniform1f(uMotion, 1.0);
    gl.uniform1f(uFire, 1.0 + 0.25 * hoverGain);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    if (canvas.style.opacity === '0') canvas.style.opacity = '1'; // fade-in al primer pintado
    schedule();
  }
  function schedule() { if (running && !raf) raf = requestAnimationFrame(frame); }
  function start() { if (running) return; running = true; t0 = now() - 0; schedule(); }
  function stop() { running = false; if (raf) { cancelAnimationFrame(raf); raf = 0; } }
  function maybeRun() { if (visible && inView && texReady) start(); else stop(); }

  // pausas por visibilidad / viewport / bateria
  document.addEventListener('visibilitychange', function () { visible = !document.hidden; maybeRun(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { inView = es[0].isIntersecting; maybeRun(); }, { threshold: 0 }).observe(root);
  }
  // perdida/recuperacion de contexto -> revelar img mientras tanto
  canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); stop(); canvas.style.opacity = '0'; });
  canvas.addEventListener('webglcontextrestored', function () { if (buildProgram()) { texReady = false; loadTexture(); maybeRun(); } });

  // la textura (164 KB) se baja cuando la orbe va a verse: si arranca esperando detras del hero de la portada
  // (oraculo-orbe--espera), espera con ella; en las demas paginas, como siempre (version unica de la portada, 26-sep-2026)
  function cargaCuandoSeVea() {
    if (!root.classList.contains('oraculo-orbe--espera') || !('MutationObserver' in window)) { loadTexture(); return; }
    var mo = new MutationObserver(function () {
      if (!root.classList.contains('oraculo-orbe--espera')) { mo.disconnect(); loadTexture(); }
    });
    mo.observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  // arranque (sin competir con el LCP)
  function boot() {
    if (!buildProgram()) { canvas.remove(); window.__mpOrbe = false; return; }
    cargaCuandoSeVea();
    window.addEventListener('pointermove', onPointer, { passive: true });
    armTilt();
    window.addEventListener('resize', resize, { passive: true });
    maybeRun();
  }
  try {
    if ('requestIdleCallback' in window) requestIdleCallback(boot, { timeout: 1500 }); else setTimeout(boot, 200);
  } catch (e) { /* cualquier fallo: se queda el <img> */ }
})();
